import { Modal } from 'stories/components'

import { getPlaceholderValue } from './types'

interface RemovePlaceholderModalProps {
  isOpen: boolean
  onClose: () => void
  removeModalValue: string
  removeModalTitle: string
  selectedPlaces: string[]
  onRemoveAtIndex: (index: number) => void
}

export const RemovePlaceholderModal = ({
  isOpen,
  onClose,
  removeModalValue,
  removeModalTitle,
  selectedPlaces,
  onRemoveAtIndex,
}: RemovePlaceholderModalProps) => {
  return (
    <Modal title="Select Instance to Remove" isOpen={isOpen} titleOkay="" onClose={onClose} titleCancel="Cancel">
      <>
        <p className="text-sm text-gray-700 mb-4">
          Multiple instances of <span className="font-semibold">{removeModalValue}</span> exist in Headers. Select which
          one to remove:
        </p>
        <div className="space-y-2">
          {selectedPlaces.map((place, index) => {
            const compareValue = getPlaceholderValue(removeModalTitle, removeModalValue)
            if (place !== compareValue) return null
            return (
              <div
                key={index}
                className="flex items-center justify-between p-3 border border-gray-200 rounded hover:bg-gray-50 cursor-pointer"
                onClick={() => onRemoveAtIndex(index)}
              >
                <span className="text-sm">
                  Position {index + 1}: {place}
                </span>
                <button className="text-xs text-red-600 hover:text-red-800 px-2 py-1 border border-red-600 rounded">
                  Remove
                </button>
              </div>
            )
          })}
        </div>
      </>
    </Modal>
  )
}
